import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import LoadingComp from "../../components/re-usable/loading/loading";

const CareerStudent = () => {
  const breadcrumbPath = `Careers%2FStudent`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const [htmlString, setHtmlString] = useState("Loading...");

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${breadcrumbPath}`));
  }, [dispatch]);

  useEffect(() => {
    if (RapsEuropeData[0]) {
      if (RapsEuropeData[0].result[0] && RapsEuropeData[0].result[0].description) {
        setHtmlString(RapsEuropeData[0].result[0].description);
      }
    }
  }, [RapsEuropeData]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  useEffect(() => {
    if (isPublished) {
      if (RapsEuropeData[0].result[0]?.javaScriptField) setScriptHtmlString(RapsEuropeData[0].result[0]?.javaScriptField);
    }
  }, [isPublished])
  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={breadcrumbPath} isBreadcrumbpath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: htmlString }}></div>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0].result[0].councilDescription }}></div>
      </TwoColumnLayOut>
    </>
  );
};

export default CareerStudent